var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#06B6D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20H27.5276C26.6257 20 25.8354 20.6036 25.5981 21.4738L24.4634 25.6341C24.0603 27.1122 21.9617 27.1063 21.5669 25.626L18.4653 13.9948C18.0683 12.506 15.9535 12.5117 15.5645 14.0027L14.39 18.5048C14.1603 19.3855 13.3649 20 12.4548 20H10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard6);
export default __webpack_public_path__ + "static/media/creation-card-6.524f0ed5d881f00d919e9308720fa2cd.svg";
export { ForwardRef as ReactComponent };